import { isPast, parse } from 'core/utils/date'

import formatDate from 'legacy/utils/date/formatDate'

import { type DistanceUnit } from '../domain/DistanceUnit'
import { type Proposal, type ProposalStep } from '../domain/Proposal'
import { type RequestForProposal } from '../domain/RequestForProposal'

export function formatRateType(rfpRateType?: string) {
  return rfpRateType ?? '-'
}

export function formatContractDate(contractStart: string, contractEnd: string): string {
  const dateFormat = 'MMM, d, yyyy'

  const normalizedStart = parse(contractStart, 'yyyy-MM-dd', new Date())
  const normalizedEnd = parse(contractEnd, 'yyyy-MM-dd', new Date())

  const start = new Date(normalizedStart)
  const end = new Date(normalizedEnd)

  return `${formatDate(start, dateFormat)} → ${formatDate(end, dateFormat)}`
}

export function formatContractDeadline(contractDeadline: string): string {
  const date = new Date(contractDeadline)

  const dateFormat = 'MMM, d, yyyy @ p'
  return `${formatDate(date, dateFormat)}`
}

export function formatDeadline(proposal: Proposal, step: ProposalStep = 'bid') {
  if (step === 'award' && proposal.awardConfirmationDeadline) {
    return formatContractDeadline(proposal.awardConfirmationDeadline.toISOString())
  }

  return formatContractDeadline(proposal.rfp.requestDeadline)
}

export function getDeadlineColorTokenIndicator(
  proposal: Proposal,
  disabled: boolean = false,
  step: ProposalStep = 'bid'
) {
  if (disabled) return 'color-neutral-light'

  const deadline =
    step === 'award' && proposal.awardConfirmationDeadline
      ? proposal.awardConfirmationDeadline
      : new Date(proposal.rfp.requestDeadline)

  return isPast(deadline) ? 'color-danger' : 'color-primary'
}

export function formatRfpStatusDate(date?: Date) {
  if (!date) return null
  const dateFormat = 'MM/dd/yyyy, p'
  return `${formatDate(date, dateFormat)}`
}

export function formatRfpMode({ mode }: RequestForProposal) {
  switch (mode) {
    case 'full_truck_load':
      return 'FTL'
    case 'less_than_truckload':
      return 'LTL'
    case 'drayage':
      return 'Drayage'
    case 'intermodal':
      return 'Intermodal'
    default:
      return 'N/A'
  }
}

export function formatDistanceLabel(distanceUnit: DistanceUnit, rateType: string) {
  return ` Rate per ${distanceUnit === 'miles' ? 'Mile' : 'Kilometers'} ${rateType}`
}

export function formatDistanceUnitShorthand(distanceUnit: DistanceUnit) {
  return distanceUnit === 'miles' ? 'mi' : 'km'
}
